import { AppWrap, MotionWrap } from "../../wrapper";
import './About.scss';
import { images } from "../../constants"

function About() {

  return (
    <div className="about">
     <div className="about_main">
        {/* LEFT IMAGE */}
        <div className="left_side">
          <img src={images.founder} alt="design" />
        </div>

        {/* CENTER CONTENT */}
        <div className="center_side">
          {/* MAIN HEADING */}
          <h1>Gomal Design Studio</h1>

          {/* SUB HEADING 1 */}
          <h3 className="about-subheading">
            Introduction
          </h3>

          <p>
            Gomal Design Studio operates as your remote architectural department,
            providing the expert hands and minds to keep your projects on track
            and help your firm grow efficiently. Consider us a seamless extension
            of your team, responsible for delivering production-ready work across
            the entire architectural workflow.
          </p>
          {/* SUB HEADING 2 */}
          <h3 className="about-subheading">
            Our Journey
          </h3>

          <p>
            Founded by Saif Rehman and Aziz Ur Rehman, Gomal Design Studio grew from a successful freelance journey on Fiverr and Upwork into a modern, remote service model that provides high-quality drawings, visuals, and documentation with clarity and precision.
          </p>

          {/* SUB HEADING 3 */}
          <h3 className="about-subheading">
            Vision
          </h3>

          <p>
            To become the most trusted remote partner for architects, designers,
            and developers worldwide. We aim to empower your success by delivering
            reliable, high-quality production services that help you scale your
            practice and deliver exceptional projects.
          </p>

          {/* SUB HEADING 4 */}
          <h3 className="about-subheading">
            Mission
          </h3>

          <p>
            Our mission is to empower our clients&apos; success by providing
            reliable, high-quality architectural services. We strive to be the
            backbone of your project, delivering insightful design, precise 2D
            drafting, immersive 3D modeling & rendering, and integrated BIM
            solutions. We bridge the gap between traditional studio overhead and
            modern, on-demand expertise.
          </p>
        </div>

        {/* RIGHT IMAGE */}
        <div className="right_side">
          <div>
            <img src={images.co_founder} alt="design" />
          </div>
        </div>
      </div>
    <div className="about_approch">
      <div className="about_approch_left">
      <div className="about_steps about_steps_bg">
        <img src={images.aboutinfobg} alt="bg img" />
        <h1>Consultation & Design Brief</h1> 
        <div className="about_steps_inner">
          <p className="steps">Step 1</p>
          <p className="description">It all starts with your story. We sit down with you to listen not just to your needs and wishes, but to your vision for the life you want to live in this space. We combine this with a practical site assessment and a review of any regulations, laying a solid and inspired foundation for everything that follows.</p>
        </div>
      </div>
      <hr />
      <div className="about_steps">
         <h1>Conceptual Phase</h1> 
        <div className="about_steps_inner">
          <p className="steps">Step 2</p>
          <p className="description">We translate our conversations into initial concepts, using sketches, mood boards, and 3D visualizations. You'll see your space take shape, exploring spatial flow, aesthetic style, and the overall feeling. This phase is all about creative exploration and ensuring the direction feels uniquely.</p>
        </div>
      </div>
      <hr />
      <div className="about_steps">
         <h1>Design – Refine & Define</h1> 
        <div className="about_steps_inner">
          <p className="steps">Step 3</p>
          <p className="description">With a chosen concept we're all excited about, we dive into the details. We develop design technically, integrating structural, mechanical, and electrical elements. We'll finalize material palettes, fixtures, and finishes, refining every detail in close collaboration with you to ensure the design is as practical as it is beautiful.</p>
        </div>
      </div>
      <hr/>
      <div className="about_steps">
         <h1>Document & Deliver</h1> 
        <div className="about_steps_inner">
          <p className="steps">Step 4</p>
          <p className="description">We transform our refined design into a comprehensive set of detailed construction drawings and documents. This is the build-ready toolkit that guides your contractor with precision, ensuring the design is executed flawlessly. We manage the technicalities, assist with permits, and ensure quality is maintained from paper to build form.</p>
        </div>
      </div>
      </div>
      <div className="about_approch_right">
        <div className="about_approch_upper">
          <h1>See how we work from start to completion</h1>
          <p>Join us on a clear and collaborative journey through our design process. We begin by listening to your vision, then carefully shape it through architecture, interiors, 3D visualization, and BIM precision, ensuring every detail is thoughtfully planned for your cozy bedroom, functional office, or complete residential transformation</p>
        </div>
        <div className="images_wrapper">
          <img className="main-img" src={images.about_img3} alt="design" />
          <img className="overlay-img" src={images.about_img4} alt="design" />
        </div>
      </div>
    </div>
    </div>
  );
}

export default AppWrap(
  MotionWrap(About, "app__about"),
  "about",
  "app__whitebg",
  false,
  false,
  false
);